import analiticaInstance from '@/vendor/analitica.vendor'

/**
 * @typedef {import('@stone-payments/analitica').EventFactory} EventFactory
 * @description This is the event that will be sent to the Amplitude plugin
 * @description import Amplitude from '@amplitude/sales.amplitude'
 * @example Amplitude.events.actions.refoundBoletoClicked()
 * @description
 * @example context: { filters: {}, viewed: {loadView: () => ({})}, actions: {} }
 */

const chargesEvents = analiticaInstance.eventFactory('Charge', {
  view: {
    loadView: filters => ({
      label: 'sales - charges list page viewed',
      metadata: { filters }
    }),
    loadDetailsView: filters => ({
      label: 'sales - charges details page viewed',
      metadata: { filters }
    })
  },
  filters: {},
  actions: {
    chargeDetailsButtonClicked: () => ({
      label: 'sales - charges list details button clicked'
    }),
    refoundBoletoClicked: () => ({
      label: 'sales - charges details request refound boleto clicked'
    }),
    exportDataClicked: () => ({
      label: 'sales - charges list export data clicked'
    }),
    refreshListClicked: () => ({
      label: 'sales - charges list refresh clicked'
    }),
    detailsHistoryItemClicked: () => ({
      label: 'sales - charges details history item clicked'
    }),
    detailsOrderClicked: () => ({
      label: 'sales - charges details order clicked'
    }),
    detailsReceiverClicked: () => ({
      label: 'sales - charges details receiver clicked'
    }),
    detailsCostumerClicked: () => ({
      label: 'sales - charges details costumer clicked'
    }),
    detailsHelpMessageClicked: () => ({
      label: 'sales - charges details help message link clicked'
    }),
    detailsRefundClicked: open => ({
      label: 'sales - charges details refund modal opened',
      metadata: { open }
    }),
    detailsSimulatorPaymentsClicked: () => ({
      label: 'sales - charges details simulate payments modal opened'
    }),
    detailsButtonClicked: metadata => ({
      label: 'sales - orders details action button clicked',
      metadata: {
        action: metadata
      }
    })
  }
})

export { chargesEvents }
